import React, { useEffect, useState, useRef } from "react";
import weather from "../assets/weather.png";
import doctorp from "../assets/doctorp.png";
import drpassport from "../assets/doc.jpg";
import clinic from "../assets/clinic.jpg";
import { BsBellFill, BsFillCalendar2DateFill } from "react-icons/bs";
import { BiSearch } from "react-icons/bi";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { AiFillClockCircle, AiFillWechat, AiOutlineFile, AiFillCalendar, AiFillEye } from "react-icons/ai";
import { FiLogOut, FiActivity, FiTrendingUp, FiCreditCard, FiSettings } from "react-icons/fi";
import { FaUserMd, FaStethoscope, FaHeartbeat, FaUser } from "react-icons/fa";
import { MdSchedule, MdLocalHospital } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import BottomNav from "./BottomNav";
import AppointmentCard from "./Appointment/AppointmentCard";
import { getAppointmentAction, getClinicsAction, getDoctorsAction } from "../redux/actions/appointmentActions";
import { useDispatch, useSelector } from "react-redux";
import { logoutUserAction } from "../redux/actions/userActions";
import { toast } from "../utils/toast";
import { check_token } from "../utils";
import swal from "sweetalert";

function HomeDashboard() {
  const navigate = useNavigate();
  const [active, setActive] = useState(false);
  const [upcomingAppointments, setUpcomingAppointments] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const dropdownRef = useRef(null);

  const [notifications, setNotifications] = useState(
    JSON.parse(localStorage.getItem("notifications"))
  );

  const dispatch = useDispatch();
  const store = useSelector((state) => state.getAppointmentAction);
  const docStore = useSelector((state) => state.getDoctorsAction);
  const logout = useSelector((state) => state.logOutUser);
  console.log('log', store);
  const clickHandler = () => {
    setActive(!active);
  };

  const handleShowPatientCard = () => {
    navigate('/patient-card');
    setActive(false);
  };

  const handleLogout = () => {
    swal({
      title: "Are you sure?",
      text: "Do you want to log out?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willLogout) => {
      if (willLogout) {
        // Trigger the loading component in the background if possible, or just await
        await dispatch(logoutUserAction());
        navigate('/login');
      }
      clickHandler();
    });
  };


  useEffect(() => {
    const initializeDashboard = async () => {
      try {
        // Check authentication first
        const isTokenValid = await check_token();
        if (!isTokenValid) {
          console.warn('Token validation failed, redirecting to login');
          navigate('/login');
          return;
        }

        const userInfo = JSON.parse(localStorage.getItem("userInfo"));
        if (!userInfo?.id) {
          console.warn('No user info found, redirecting to login');
          navigate('/login');
          return;
        }

        // Only make API calls if authenticated
        dispatch(getClinicsAction());
        
        if (!store.success) {
          dispatch(getAppointmentAction(userInfo.id));
        }
      } catch (error) {
        console.error('Dashboard initialization error:', error);
        navigate('/login');
      }
    };

    initializeDashboard();
  }, [dispatch, store.success, navigate]); 

  useEffect(() => {
    if (store?.success && store?.data?.data?.upcoming) {
      setUpcomingAppointments(store.data.data.upcoming);
      console.log('store?.data?.data?.upcoming', store.data.data.upcoming);
    }
  }, [store?.success, store?.data?.data?.upcoming]);


  // Handle click outside dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActive(false);
      }
    };

    // Add event listener when dropdown is active
    if (active) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    // Cleanup event listeners
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [active]);


  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50">
      <div className="w-full max-w-md mx-auto bg-white shadow-2xl relative">
          {/* Hero Section with Gradient Background */}
          <div className="relative bg-primary100 pb-16">
          {/* Decorative Background Elements */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-4 left-4 w-8 h-8 bg-white rounded-full animate-pulse"></div>
            <div className="absolute top-12 right-8 w-4 h-4 bg-white rounded-full animate-pulse delay-100"></div>
            <div className="absolute bottom-8 left-8 w-6 h-6 bg-white rounded-full animate-pulse delay-200"></div>
            <div className="absolute bottom-4 right-4 w-3 h-3 bg-white rounded-full animate-pulse delay-300"></div>
          </div>

          {/* Header Content */}
          <div className="relative z-10 px-6 py-6">
            {/* Top Navigation */}
            <div className="flex justify-between items-start mb-6">
              <div className="flex-1">
                <p className="text-white/90 text-sm font-medium">
                  {new Date().getHours() < 12
                    ? `Good Morning`
                    : new Date().getHours() < 18
                    ? `Good Afternoon`
                    : `Good Evening`}
                </p>
                <h1 className="text-white text-xl sm:text-2xl font-bold mt-1">
                  {JSON.parse(localStorage.getItem("userInfo"))?.firstname || "User"}
                </h1>
                <p className="text-white/80 text-sm mt-1 font-medium">
                  {JSON.parse(localStorage.getItem("hospital_name")) || "Healthcare Portal"}
                </p>
              </div>

              <div className="flex items-center space-x-4">
                {/* Notification Bell */}
                <Link to="/notification" className="relative">
                  <div className="p-2 bg-white/20 rounded-full backdrop-blur-sm hover:bg-white/30 transition-all duration-300">
                    <BsBellFill className="text-white text-xl" />
                    {notifications !== false && (
                      <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full border-2 border-white"></span>
                    )}
                  </div>
                </Link>

                {/* Menu Dropdown */}
                <div className="relative" ref={dropdownRef}>
                  <button
                    onClick={clickHandler}
                    className="p-2 bg-white/20 rounded-full backdrop-blur-sm hover:bg-white/30 transition-all duration-300"
                  >
                    <HiOutlineDotsVertical className="text-white text-xl" />
                  </button>
                  {active && (
                    <>
                      {/* Backdrop */}
                      <div className="fixed inset-0 z-[9998]" onClick={() => setActive(false)}></div>
                      {/* Dropdown */}
                      <div className="absolute right-0 top-10 bg-white rounded-xl shadow-2xl border border-gray-100 py-2 min-w-[180px] z-[9999]">
                      <button
                        onClick={handleShowPatientCard}
                        className="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-50 flex items-center space-x-2"
                      >
                        <FaUser className="text-secondary100" />
                        <span>Profile</span>
                      </button>
                      <button
                        onClick={() => {
                          navigate('/notification-settings');
                          setActive(false);
                        }}
                        className="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-50 flex items-center space-x-2"
                      >
                        <FiSettings className="text-primary100" />
                        <span>Settings</span>
                      </button>
                      <button
                        onClick={handleLogout}
                        className="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-50 flex items-center space-x-2"
                      >
                        <FiLogOut className="text-red-500" />
                        <span>Logout</span>
                      </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Quick Stats Cards */}
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 border border-white/30">
                <div className="flex items-center space-x-3">
                  <div className="p-2 bg-white/30 rounded-xl">
                    <FaStethoscope className="text-white text-lg" />
                  </div>
                  <div>
                    <p className="text-white/80 text-xs">Total Visits</p>
                    <p className="text-white text-xl font-bold">
                      {store?.data?.data?.visit_count ?? 0}
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 border border-white/30">
                <div className="flex items-center space-x-3">
                  <div className="p-2 bg-white/30 rounded-xl">
                    <AiFillCalendar className="text-white text-lg" />
                  </div>
                  <div>
                    <p className="text-white/80 text-xs">Appointments</p>
                    <p className="text-white text-xl font-bold">
                      {store?.data?.data?.appt_count ?? 0}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Floating Action Card */}
          <div className="absolute -bottom-12 left-4 right-4 bg-white rounded-2xl shadow-xl p-4 border border-gray-100 z-10">
            <div className="flex items-center justify-between">
              <div className="flex-1 pr-4">
                <h3 className="text-gray-800 font-bold text-lg mb-2">Book Appointment</h3>
                <p className="text-gray-600 text-sm mb-4">
                  Schedule your next visit with our healthcare professionals
                </p>
                <Link to="/first-appointment">
                  <button className="bg-primary100 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center space-x-2">
                    <MdSchedule />
                    <span>Book Now</span>
                  </button>
                </Link>
              </div>
              <div className="flex-shrink-0">
                <img src={doctorp} alt="Doctor" className="w-20 h-20 object-cover rounded-xl" />
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="pt-16 px-4 pb-24">
          {/* Quick Actions Grid */}
          <div className="mb-8 mt-4">
            <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
              <FiActivity className="mr-2 text-primary100" />
              Quick Actions
            </h2>
            <div className="grid grid-cols-2 gap-4">
              <Link to="/lab_results" className="group">
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-4 rounded-2xl border border-blue-200 hover:shadow-lg transition-all duration-300 group-hover:scale-105">
                  <div className="flex flex-col items-center text-center">
                    <div className="p-3 bg-blue-500 rounded-xl mb-3 group-hover:bg-blue-600 transition-colors">
                      <AiOutlineFile className="text-white text-2xl" />
                    </div>
                    <h3 className="font-semibold text-gray-800 text-sm">Lab Results</h3>
                    <p className="text-gray-600 text-xs mt-1">View recent tests</p>
                  </div>
                </div>
              </Link>

              <Link to="/appointment" className="group">
                <div className="bg-gradient-to-br from-green-50 to-green-100 p-4 rounded-2xl border border-green-200 hover:shadow-lg transition-all duration-300 group-hover:scale-105">
                  <div className="flex flex-col items-center text-center">
                    <div className="p-3 bg-green-500 rounded-xl mb-3 group-hover:bg-green-600 transition-colors">
                      <FaUserMd className="text-white text-2xl" />
                    </div>
                    <h3 className="font-semibold text-gray-800 text-sm">Appointments</h3>
                    <p className="text-gray-600 text-xs mt-1">Manage visits</p>
                  </div>
                </div>
              </Link>

              <Link to="/queue-wait" className="group">
                <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-4 rounded-2xl border border-purple-200 hover:shadow-lg transition-all duration-300 group-hover:scale-105">
                  <div className="flex flex-col items-center text-center">
                    <div className="p-3 bg-purple-500 rounded-xl mb-3 group-hover:bg-purple-600 transition-colors">
                      <AiFillClockCircle className="text-white text-2xl" />
                    </div>
                    <h3 className="font-semibold text-gray-800 text-sm">Queue Status</h3>
                    <p className="text-gray-600 text-xs mt-1"> Waiting time</p>
                  </div>
                </div>
              </Link>

              <Link to="/payment" className="group">
                <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 rounded-2xl border border-orange-200 hover:shadow-lg transition-all duration-300 group-hover:scale-105">
                  <div className="flex flex-col items-center text-center">
                    <div className="p-3 bg-orange-500 rounded-xl mb-3 group-hover:bg-orange-600 transition-colors">
                      <FiTrendingUp className="text-white text-2xl" />
                    </div>
                    <h3 className="font-semibold text-gray-800 text-sm">Payments</h3>
                    <p className="text-gray-600 text-xs mt-1">View transactions</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          {/* Upcoming Appointments */}
          <div className="mb-8 w-full">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold text-gray-800 flex items-center">
                <FaHeartbeat className=" text-primary100" />
                Upcoming Appointments
              </h2>
              <Link to="/appointment" className="text-primary100 font-semibold text-sm hover:text-secondary100 transition-colors">
                View All
              </Link>
            </div>
            
            <div className="space-y-2 w-full">
              {upcomingAppointments?.length > 0 ? (
                upcomingAppointments
                  .slice(0, 2)
                  .map((appointment) => (
                    <AppointmentCard
                      key={appointment.id}
                      pics={clinic}
                      name={appointment.clinic_name}
                      post={"Clinic"}
                      date={appointment.appt_date}
                      time={appointment.appt_time}
                      mode={appointment.appt_type}
                      status={appointment.status}
                    />
                  ))
              ) : (
                <div className="bg-gray-50 rounded-2xl p-8 text-center">
                  <MdLocalHospital className="text-gray-400 text-4xl mx-auto mb-3" />
                  <p className="text-gray-500 font-medium">No upcoming appointments</p>
                  <p className="text-gray-400 text-sm mt-1">Book your next visit today</p>
                  <Link to="/first-appointment">
                    <button className="mt-4 bg-primary100 text-white px-6 py-2 rounded-xl font-semibold hover:bg-secondary100 transition-colors">
                      Book Appointment
                    </button>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>

        <BottomNav color={"text-primary100"} />
      </div>

    </div>
  );
}

export default HomeDashboard;
